import { actionTypes } from "./actionTypes";
export const setTimeDiff = (payload) => ({
    type: actionTypes.TIME_SET_DIFF,
    payload: payload
});
export const fetchTime = () => ({
    type: actionTypes.TIME_FETCH
});
//# sourceMappingURL=actions.js.map